import React from "react";
import "./InfoCardsSection.css";

export default function InfoCardsSection() {
  return (
    <section className="info-section" id="journal-information">
      <div className="info-background">
        <div className="info-overlay">
          <h2 className="info-heading">Journal Information</h2>

          <div className="info-container">
            <div className="info-card">
              <h3>General Information</h3>
              <p>
                <strong>ISSN :</strong> -
              </p>
              <p>
                <strong>Frequency :</strong> One Issue Per Year
              </p>
              <p>
                <strong>Email :</strong> ijacna@gmail.com
              </p>
            </div>

            <div className="info-card">
              <h3>Conference</h3>
              <p>Update Soon</p>
            </div>

            <div className="info-card">
              <h3>Call For Paper</h3>
              <p>📄 Call For Paper</p>
            </div>

            <div className="info-card">
              <h3>Impact Factor</h3>
              <p>Update Soon</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
